/**
 * App Language Provider
 * Add more locales here
 */
// import { addLocaleData } from 'react-intl';
// import enLang from './entries/en_US';
import koLang from './entries/ko_KO';
import viLang from './entries/vi_VN';

const AppLocale = {
  // en: enLang,
  ko: koLang,
  vi: viLang,
};

// addLocaleData(AppLocale.en.data);
// addLocaleData(AppLocale.ko.data);
// addLocaleData(AppLocale.vi.data);

export default AppLocale;
